<template>
  <v-card>
    <v-form @submit.prevent="submitEditVehicle()" ref="editVehicleForm">
      <v-container grid-list-lg>
        <v-layout wrap>
          <dialog-header :title="'Edit'" :details="`${vehicle.name} (${vehicle.contractor.name})`"></dialog-header>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="editedVehicle.name"
              label="* Registration"
              autofocus
              :loading="loading"
              :rules="nameRules"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-autocomplete
              label="* Vehicle Type"
              :items="vehicleTypes"
              v-model="editedVehicle.vehicleTypeId"
              item-text="name"
              item-value="id"
              :rules="vehicleTypeRules"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Maximum Allowable Cartage Tonnage"
              v-model.number="editedVehicle.maxTonnage"
              :rules="maxTonnageRules"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="editedVehicle.details"
              label="Details"
              :loading="loading"
              :rules="detailsRules"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="VIN" v-model="editedVehicle.vin" :rules="vinRules"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-switch
              :hint="!editedVehicle.contractor.active ? 'This Vehicle is set to Inactive by its related Sub-Contractor' : null"
              persistent-hint
              label="Active"
              :color="$store.state.global.pages.vehicle.color"
              v-model="editedVehicle.active"
              :disabled="!!allowInductionEntry && !userAuthClass"
            ></v-switch>
          </v-flex>
          <v-flex xs12 sm6 v-if="$store.state.user.userAuthClass.name === 'Administrator'">
            <v-switch label="Request" v-model="editedVehicle.request" :disabled="!userAuthClass"></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="different">
          <v-btn :color="primaryGrey" flat @click="discard()">Discard?</v-btn>
          <v-btn :color="primaryGreen" flat type="submit" :loading="loading">Save</v-btn>
        </div>
        <div v-else>
          <v-btn :color="primaryGrey" flat @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-form>
    <inductions-panel
      :projects="projects"
      :currentProjects="currentProjects"
      :discarding="discarding"
      @selectedChanged="onSelectedChanged"
      @discard="discarding = false"
      v-if="initData"
    ></inductions-panel>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import VehicleService from '@/services/requests/vehicleService'
import VehicleProjectService from '@/services/requests/vehicleProjectService'

// MIXINS
import VehicleValidation from '@/services/validation/vehicleValidation'

// COMPONENTS
import DialogHeader from '@/components/ui/dialogHeader'
import InductionsPanel from '@/components/ui/inductionsPanel'

export default {
  mixins: [VehicleValidation],
  components: {
    DialogHeader,
    InductionsPanel,
  },
  data() {
    return {
      editedVehicle: Object.assign({}, this.vehicle),
      loading: false,
      selectedProjects: [],
      currentProjects: [],
      discarding: false,
      initData: false,
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    discard() {
      this.discarding = true
      this.editedVehicle = Object.assign({}, this.vehicle)
      this.selectedProjects = [...this.currentProjects]
      this.close()
    },
    submitEditVehicle() {
      if (!this.$refs.editVehicleForm.validate()) {
        return
      }
      this.save()
    },
    getVehicleProjectsByVehicle() {
      VehicleProjectService.getVehicleProjectsByVehicle(this.vehicle.id)
        .then((result) => {
          this.setCurrentProjects(result.data.result)
          this.initData = true
        })
        .catch((err) => {
          this.snackError()
          console.log(err)
        })
    },
    setCurrentProjects(data) {
      this.selectedProjects = []
      this.currentProjects = []
      for (var record of data) {
        this.selectedProjects.push(record.projectId)
        this.currentProjects.push(record.projectId)
      }
    },
    save() {
      var postedVehicle = this.editedVehicle
      postedVehicle.selectedProjects = this.selectedProjects
      this.loading = true
      VehicleService.updateVehicle(this.editedVehicle, this.editedVehicle.id)
        .then((result) => {
          this.loading = false
          this.$store.commit('vehicles/updateArrayStateByValue', {
            prop: 'vehicles',
            value: this.vehicle,
            editedValue: result.data.result.vehicle,
          })
          this.editedVehicle = Object.assign({}, result.data.result.vehicle)
          this.setCurrentProjects(result.data.result.vehicleProjects)
          this.snack({ color: 'green', text: 'Vehicle was edited' })
          this.close()
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
          this.snackError()
        })
    },
    onSelectedChanged(val) {
      this.selectedProjects = val
    },
  },
  computed: {
    vehicleTypes: Store.getSet({ store: 'vehicleTypes', prop: 'vehicleTypes' }),
    projects: Store.getSet({ store: 'projects', prop: 'projects' }),
    different() {
      if (
        !this._.isEqual(this.vehicle, this.editedVehicle) ||
        !this._.isEqual(
          this.selectedProjects.sort().join(','),
          this.currentProjects.sort().join(',')
        )
      ) {
        return true
      } else {
        return false
      }
    },
    formData() {
      return new FormData()
    },
  },
  async mounted() {
    await this.getVehicleProjectsByVehicle()
  },
  props: {
    vehicle: Object,
  },
}
</script>

<style>
</style>
